import { gtmApi } from '../api';
import { ACTION_TYPES } from './store/gtm.action';

export const initializeGtm = gtmContainerId => async dispatch => {
  await gtmApi.initGtm(gtmContainerId);

  await dispatch({
    type: ACTION_TYPES.INITIALIZE_GTM,
  });
};

export const updateContainerId = (gtmContainerId: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.UPDATE_CONTAINER_ID,
    payload: gtmContainerId,
  });

  if (gtmContainerId && gtmContainerId !== '') {
    await dispatch(initializeGtm(gtmContainerId));
  }
};

export const gtmEvent = (eventCategory: string, eventAction: string, eventValue: string) => async (dispatch, getState) => {
  const { containerId } = await getState().gtm;
  const subscription = await getState().step.subscription;

  if (containerId)
    await gtmApi.gtmEvent(containerId, eventCategory, eventAction, subscription ? subscription.subscriptionNumber : undefined, eventValue);
};
